import { useState, Fragment } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

interface FAQItem {
  question: string;
  answer: string;
}

const recrutenFAQs: FAQItem[] = [
  { question: "Was ist recruiTen.AI?", answer: "recruiTen.AI ist eine KI-Lösung speziell für Personalberatungen und Recruiting-Agenturen. Sie automatisiert den gesamten Recruiting-Prozess – von der Kandidatenidentifikation über die personalisierte Erstansprache bis zur automatischen Terminvereinbarung." },
  { question: "Woher kommt der Name recruiTen.AI?", answer: "Der Name steckt das Versprechen direkt im Produkt: \u201ERecruiten\u201C \u2013 also das aktive Suchen und Ansprechen von Kandidaten \u2013 kombiniert mit \u201ETen\u201C f\u00FCr den Faktor 10. recruiTen.AI macht Recruiter bis zu 10x effizienter. Der Name ist Programm." },
  { question: "Wie hilft KI beim Recruiting?", answer: "Statt manuell Profile zu suchen und Nachrichten zu verfassen, übernimmt die KI bis zu 10 parallele Suchstrategien gleichzeitig, schreibt personalisierte Ansprachen auf Basis von Profil und Karriereweg und antwortet in Echtzeit auf Rückmeldungen – rund um die Uhr." },
  { question: "Wie viel effizienter werde ich als Recruiter mit KI?", answer: "Unsere Nutzer steigern ihre Effizienz um das bis zu 10-fache. Aufgaben, die früher einen ganzen Arbeitstag beansprucht haben, erledigt recruiTen.AI in wenigen Minuten." },
  { question: "Ist recruiTen.AI DSGVO-konform?", answer: "Ja. recruiTen.AI ist vollständig in Europa gehostet und entspricht allen Anforderungen der DSGVO. Keine Daten verlassen den europäischen Rechtsraum." },
  { question: "Für wen ist recruiTen.AI geeignet?", answer: "Das Tool richtet sich an Personalberater, Headhunter und Recruiting-Agenturen jeder Größe – vom Einzelberater bis zur etablierten Boutique-Beratung." },
  { question: "Was unterscheidet recruiTen.AI von generischen KI-Tools wie ChatGPT?", answer: "recruiTen.AI wurde nicht im Labor entwickelt, sondern direkt aus dem Alltag einer aktiven Personalberatung heraus. Es ist kein generisches KI-Tool, sondern eine spezialisierte Lösung mit trainierten Workflows speziell für den Recruiting-Prozess." },
  { question: "Kann KI wirklich personalisierte Kandidatenansprachen schreiben?", answer: "Ja. recruiTen.AI analysiert das Profil, den Karriereweg und die aktuelle Position eines Kandidaten und erstellt daraus eine individuelle Ansprache – keine Massenmail, sondern eine Nachricht, die sich persönlich anfühlt. Die Response-Rates steigen dadurch messbar." },
  { question: "Wie lange dauert die Einrichtung von recruiTen.AI?", answer: "Die Implementierung ist in wenigen Minuten abgeschlossen. Es gibt keine komplexe IT-Integration – recruiTen.AI ist darauf ausgelegt, schnell einsatzbereit zu sein." },
  { question: "Ersetzt recruiTen.AI meinen Recruiter?", answer: "Nein. recruiTen.AI ersetzt keine Menschen, sondern eliminiert die repetitiven Aufgaben, die wertvolle Zeit kosten. Recruiter können sich auf das konzentrieren, was wirklich zählt: Beziehungen aufbauen, Kandidaten beraten und Abschlüsse erzielen." },
  { question: "Funktioniert recruiTen.AI auch für Nischenbranchen?", answer: "Ja. Die KI lässt sich auf spezifische Branchen, Berufsfelder und Zielgruppen trainieren – ob IT, Finance, Engineering oder Healthcare." },
  { question: "Welche Kanäle deckt recruiTen.AI ab?", answer: "recruiTen.AI arbeitet auf den gängigen Plattformen, auf denen Kandidaten aktiv sind – darunter LinkedIn und weitere professionelle Netzwerke." },
  { question: "Was passiert, wenn ein Kandidat antwortet?", answer: "Die KI erkennt die Antwort, bewertet den Gesprächsverlauf und führt intelligente Follow-ups durch – bis hin zur automatischen Terminvereinbarung für ein Erstgespräch." },
  { question: "Kann ich als Einzelberater recruiTen.AI nutzen oder ist es nur für große Agenturen?", answer: "recruiTen.AI ist bewusst für beide Szenarien entwickelt worden. Gerade Einzelberater profitieren besonders, weil sie mit der KI die Schlagzahl einer ganzen Abteilung erreichen." },
  { question: "Wie unterscheidet sich recruiTen.AI von klassischen ATS-Systemen?", answer: "Klassische Bewerbermanagementsysteme verwalten nur eingehende Bewerbungen. recruiTen.AI hingegen geht aktiv auf Kandidaten zu – vollautomatisch und personalisiert." },
  { question: "Funktioniert recruiTen.AI auch für die Besetzung von Führungspositionen im Executive Search?", answer: "Ja. recruiTen.AI ist auch für diskrete, hochspezialisierte Suchen geeignet. Die KI recherchiert gezielt passive Kandidaten auf Führungsebene und erstellt Ansprachen, die dem Anspruch von Executive-Search-Mandaten gerecht werden – professionell, individuell und vertraulich." },
];

const zentenFAQs: FAQItem[] = [
  { question: "Was ist zenTen.AI?", answer: "zenTen.AI ist eine KI-Lösung für E-Commerce-Händler und Onlineshop-Betreiber. Sie beantwortet Kundenanfragen auf Amazon, Kaufland, eBay und weiteren Marktplätzen vollautomatisch – präzise, markenkonform und rund um die Uhr." },
  { question: "Woher kommt der Name zenTen.AI?", answer: "\u201EZen\u201C steht f\u00FCr Ruhe, Gelassenheit und Kontrolle \u2013 genau das, was H\u00E4ndler gewinnen, die zenTen.AI einsetzen. Egal ob 10 oder 1.000 Kundenanfragen t\u00E4glich eingehen: zenTen.AI beantwortet sie automatisch, und Sie bleiben ruhig. \u201ETen\u201C steht f\u00FCr den Faktor 10 \u2013 die Effizienzsteigerung, die Sie dabei erreichen. Zen mal zehn." },
  { question: "Wie funktioniert die automatische Beantwortung von Kundenanfragen?", answer: "zenTen.AI liest eingehende Kundenanfragen auf allen verbundenen Plattformen, analysiert den Kontext und generiert passende Antworten – in unter 2 Minuten, ohne manuellen Aufwand. Die KI lernt kontinuierlich dazu und verbessert ihre Antwortqualität selbstständig." },
  { question: "Auf welchen Plattformen funktioniert zenTen.AI?", answer: "Aktuell unterstützt zenTen.AI Amazon, Kaufland und eBay. Weitere Marktplätze werden kontinuierlich integriert. Alle Plattformen werden zentral aus einer einzigen Oberfläche verwaltet." },
  { question: "Wie viel Zeit spare ich als Händler mit zenTen.AI?", answer: "Händler, die zenTen.AI einsetzen, werden bis zu 10x effizienter im Kundenservice. Der manuelle Aufwand für die Bearbeitung von Kundenanfragen sinkt um bis zu 90 %." },
  { question: "Ist zenTen.AI DSGVO-konform?", answer: "Ja. zenTen.AI ist vollständig in Europa gehostet und DSGVO-konform. Kundendaten werden ausschließlich auf europäischen Servern verarbeitet." },
  { question: "Was unterscheidet zenTen.AI von generischen Chatbot-Lösungen?", answer: "Grundlegend: Ein klassischer Chatbot sitzt auf einer Website und wartet, bis Besucher ihn ansprechen. zenTen.AI löst ein völlig anderes Problem – es beantwortet Kundennachrichten, die direkt über Amazon, Kaufland und weitere Marktplätze an Sie als Händler gesendet werden. Diese Plattform-Nachrichten sind zeitkritisch, beeinflussen Ihre Verkäuferbewertung und lassen sich mit keinem Website-Chatbot automatisieren. zenTen.AI wurde genau dafür entwickelt – aus dem Alltag eines echten Marktplatz-Händlers heraus." },
  { question: "Versteht zenTen.AI auch komplexe Kundenanfragen?", answer: "Ja. zenTen.AI ist trainiert auf typische E-Commerce-Szenarien wie Retouren, Lieferverzögerungen, Produktfragen und Reklamationen. Bei wirklich komplexen Fällen eskaliert die KI automatisch an einen menschlichen Mitarbeiter." },
  { question: "Wie lange dauert die Einrichtung von zenTen.AI?", answer: "Die Anbindung an die ersten Plattformen ist innerhalb weniger Minuten abgeschlossen. Keine aufwendige IT-Integration, keine langen Projektlaufzeiten." },
  { question: "Kann zenTen.AI in meinem Markennamen und Tonality antworten?", answer: "Ja. Die KI wird auf Ihre Marke, Ihren Tonfall und Ihre typischen Produktkategorien trainiert – sodass jede Antwort so klingt, als käme sie von Ihrem besten Kundenservice-Mitarbeiter." },
  { question: "Was passiert bei Anfragen, die die KI nicht beantworten kann?", answer: "zenTen.AI erkennt, wenn eine Anfrage menschliche Entscheidung erfordert, und leitet diese automatisch weiter. So bleibt die Kontrolle immer bei Ihnen." },
  { question: "Verbessert zenTen.AI meine Bewertungen auf Amazon & Co.?", answer: "Schnelle, kompetente Antworten sind einer der wichtigsten Faktoren für positive Bewertungen. Händler, die zenTen.AI einsetzen, berichten von spürbar besseren Kundenbewertungen und höherer Zufriedenheit." },
  { question: "Funktioniert zenTen.AI auch für internationale Märkte?", answer: "Ja. zenTen.AI unterstützt mehrsprachige Kommunikation – ideal für Händler, die in Deutschland, Österreich und der Schweiz sowie weiteren europäischen Märkten aktiv sind." },
  { question: "Wie lernt die KI dazu?", answer: "zenTen.AI analysiert kontinuierlich, welche Antworten zu positiven Reaktionen geführt haben, und optimiert sich selbstständig – ohne dass Sie manuell eingreifen müssen." },
  { question: "Lohnt sich zenTen.AI auch für kleinere Shops mit weniger Anfragen?", answer: "Ab einer gewissen Anfragemenge amortisiert sich zenTen.AI schnell. Gerade in Wachstumsphasen oder saisonalen Hochzeiten wie dem Weihnachtsgeschäft schützt die Lösung vor Überlastung und Qualitätsverlust im Kundenservice." },
  { question: "Ersetzt zenTen.AI meinen Kundenservice vollständig?", answer: "Nein – zenTen.AI übernimmt die repetitiven 90 % der Anfragen vollautomatisch. Ihr Team bleibt für komplexe Fälle und strategische Entscheidungen zuständig." },
];

const allFAQs = [...recrutenFAQs, ...zentenFAQs];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: allFAQs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
};

interface AccordionItemProps {
  item: FAQItem;
  isOpen: boolean;
  onToggle: () => void;
}

const AccordionItem = ({ item, isOpen, onToggle }: AccordionItemProps) => (
  <div className="border-b border-border">
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between py-4 text-left gap-4 group min-h-[3.5rem]"
    >
      <span className="text-sm md:text-base font-medium text-foreground group-hover:text-primary transition-colors">
        {item.question}
      </span>
      <span className="shrink-0 w-5 h-5 flex items-center justify-center text-muted-foreground">
        {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
      </span>
    </button>
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.25, ease: "easeInOut" }}
          className="overflow-hidden"
        >
          <p className="pb-4 text-sm text-muted-foreground leading-relaxed pr-9">
            {item.answer}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const FAQSection = () => {
  const [recrutenOpen, setRecruitenOpen] = useState<number | null>(null);
  const [zentenOpen, setZentenOpen] = useState<number | null>(null);

  const faqCount = Math.max(recrutenFAQs.length, zentenFAQs.length);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Antworten auf die wichtigsten Fragen zu unseren KI-Lösungen
          </p>
        </motion.div>

        {/* Header row: badges + titles */}
        <div className="grid lg:grid-cols-2 gap-x-12 lg:gap-x-16 mb-0">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3 bg-primary/10 text-primary">
              recruiTen.AI
            </span>
            <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-1">Häufige Fragen</h3>
            <p className="text-muted-foreground text-sm mb-6">
              Alles, was Sie über KI-Automatisierung im Recruiting und in der Direktansprache wissen müssen.
            </p>
          </motion.div>

          <motion.div
            className="hidden lg:block"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3 bg-secondary/10 text-secondary">
              zenTen.AI
            </span>
            <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-1">Häufige Fragen</h3>
            <p className="text-muted-foreground text-sm mb-6">
              Alles, was Sie über KI-Automatisierung im E-Commerce-Kundenservice wissen müssen.
            </p>
          </motion.div>
        </div>

        {/* Paired FAQ rows on desktop */}
        <div className="hidden lg:grid lg:grid-cols-2 gap-x-12 lg:gap-x-16">
          {Array.from({ length: faqCount }).map((_, i) => (
            <Fragment key={i}>
              {recrutenFAQs[i] && (
                <AccordionItem
                  item={recrutenFAQs[i]}
                  isOpen={recrutenOpen === i}
                  onToggle={() => setRecruitenOpen(recrutenOpen === i ? null : i)}
                />
              )}
              {zentenFAQs[i] && (
                <AccordionItem
                  item={zentenFAQs[i]}
                  isOpen={zentenOpen === i}
                  onToggle={() => setZentenOpen(zentenOpen === i ? null : i)}
                />
              )}
            </Fragment>
          ))}
        </div>

        {/* Mobile: stacked lists */}
        <div className="lg:hidden space-y-12">
          <div>
            {recrutenFAQs.map((faq, i) => (
              <AccordionItem
                key={i}
                item={faq}
                isOpen={recrutenOpen === i}
                onToggle={() => setRecruitenOpen(recrutenOpen === i ? null : i)}
              />
            ))}
          </div>
          <div>
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3 bg-secondary/10 text-secondary">
              zenTen.AI
            </span>
            <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-1">Häufige Fragen</h3>
            <p className="text-muted-foreground text-sm mb-6">
              Alles, was Sie über KI-Automatisierung im E-Commerce-Kundenservice wissen müssen.
            </p>
            {zentenFAQs.map((faq, i) => (
              <AccordionItem
                key={i}
                item={faq}
                isOpen={zentenOpen === i}
                onToggle={() => setZentenOpen(zentenOpen === i ? null : i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
